import React, { useState } from 'react'
import "./Website.scss"
import { FaCheck, FaFacebookF, FaInstagram, FaTelegramPlane, FaWhatsapp, FaYoutube } from "react-icons/fa";
import { FaRegCopy } from "react-icons/fa6";
import { PiUpload } from "react-icons/pi";
import { SiYoutubeshorts } from 'react-icons/si';
import PersonalInfo from '../../../../Components/PersonalInfo/PersonalInfo.jsx';
import { Link } from 'react-router-dom';
export default function Website() {
      const [activeRow, setActiveRow] = useState(null);
      const [open, setOpen] = useState(null);
        const toggleDetails = (index) => {
    setActiveRow(activeRow === index ? null : index);
  };
      const [orders] = useState([
        {
          id: '301555',
          name: 'YouTube',
           icon: <FaYoutube className='platform-icon' style={{ color: 'red' }} /> ,
        
          date: '12 Aug 2022- 12:25 am',
        point:"12 Point",
          status: 'Register',
        },
        {
          id: '601556',
          name: 'Facebook', 
          icon: <FaFacebookF className='platform-icon' style={{ color: '#3b5998' }} />,
          client: 'Osama alabyaare',
          product: 'E-book',
          date: '12 Aug 2022- 12:25 am',
        point:"12 Point",
          status: 'Views',
        },
        {
          id: '301555',
           name: 'Shorts',
          icon: <SiYoutubeshorts className='platform-icon' style={{ color: 'red' }} /> ,
        
          date: '12 Aug 2022- 12:25 am',
        point:"12 Point",
          status: 'Linck click',
        },
            {
          id: '301555',
           name: 'WhatsApp',
            icon: <FaWhatsapp className='platform-icon' style={{ color: '#25D366' }} />,
        
          date: '12 Aug 2022- 12:25 am',
        point:"12 Point",
          status: 'Register',
        },
            {
          id: '301555',
          name: 'Instagram',
           icon: <FaInstagram className='platform-icon' style={{ color: '#E1306C' }} />,
        
          date: '12 Aug 2022- 12:25 am',
        point:"12 Point",
          status: 'Linck click',
        }
      ]);
  return (
    <div className=' p-3'>
           <div className="headerr">
             <div className="stock-filters">
                              <Link to="/dashboard/Informations"  className='no-style-link '>    <button className="stock-filter ">Information</button></Link>         
              
               <Link to="/dashboard/Client-Orders"  className='no-style-link'> <button className="stock-filter">Orders</button></Link>
                       <Link to="/dashboard/Client-Payments"  className='no-style-link'> <button className="stock-filter">Payments</button></Link>
                                <Link to="/dashboard/Client-Notices"  className='no-style-link'> <button className="stock-filter">Notices</button></Link>
                                         <Link to="/dashboard/Emarketing-products"  className='no-style-link'> <button className="stock-filter actives">E-marketing</button></Link>
     
             </div>
           
             <div className="search-wrapperr">
               <input
                 type="text"
                 placeholder="Search by order id"
                 className="stock-search"
               />
               <i className="fa-solid fa-magnifying-glass search-icon"></i>
             </div>
           
             <div className="stock-header">
               <input type="date" placeholder="select dates" />
               <div className="stock-actions">
                 <button className="stock-btn blue">Filters</button>
                 <button className="stock-btn"><PiUpload/>  Export</button>
               </div>
             </div>
           </div>
                 <PersonalInfo
         userData={{
           image: "👤", // أو رابط لصورة
           online: true,
           name: "Osama Ali Ali",
           email: "Osama@gmail.com",
           role: "Client +",
         }}
         personalInfo={{
           "Contact Number": "003737737",
           "Gender": "Male",
           "Date of Birth": "1 Jan, 1985",
           "Country": "Morocco",
           "Member Since": "3 March, 2023",
         }}
         performanceInfo={{
           wallet: "EGP35.00",
           totalOrders: 150,
           balance: 50,
           totalPoints: 350,
           
         }}
          Total="Links"
       servecis1="Total Orders"
       servecis2="Total Points"
       />

          <div className="headerr">
  <div className="stock-filters">
    <Link to="/dashboard/Emarketing-products">
    <button className="stock-filter ">Products</button>
    </Link>

        <Link to="/dashboard/Emarketing-Website">
    <button className="stock-filter actives ">Website</button>
    </Link>    
    <Link to="/dashboard/Emarketing-Links">
    <button className="stock-filter ">Links</button>
    </Link>
  
  </div>

  <div className="search-wrapper">
    <input
      type="text"
      placeholder="Search by order id"
      className="stock-search"
    />
    <i className="fa-solid fa-magnifying-glass search-icon"></i>
  </div>

  <div className="stock-header">
    <input type="date" placeholder="select dates" />
    <div className="stock-actions">
     <span className="product-header col" onClick={() => setOpen(open === "Status" ? null : "Status")}>
                  Filter by date range
                  <svg className="dropdown-arrow" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L5 5L9 1" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  {open === "Status" && (
                    <div className="list-body h">
                      <ul className="list">
                       <li className="check-item">
  <span className="check-circle"></span>
  <span>User ID</span>
</li>

                     <li className="check-item">
  <span className="check-circle"></span>
  <span>Order Completed(24h)</span>
</li>
                     <li className="check-item">
  <span className="check-circle"></span>
  <span>Order Completed(30d)</span>
</li>
                     <li className="check-item">
  <span className="check-circle"></span>
  <span>Late Paid</span>
</li>
                     <li className="check-item">
  <span className="check-circle"></span>
  <span>Active Order</span>
</li>
                      
                      </ul>
                    </div>
                  )}
                </span>
          <button className="stock-btn"><PiUpload/>  Export</button>

    </div>
  </div>
</div>
            <div className="orders-table-wrapper text-center">
                 <table className="orders-table text-center">
                   <thead className=' text-center'>
                     <tr className=' text-center'>
                    
                       <th>Plat form</th>
                       <th>Link ID</th>
                       <th>Link Date</th>
                       <th>Points</th>
            
                         <th className="product-header col" onClick={() => setOpen(open === "Status" ? null : "Status")}>
                           Status
                           <svg className="dropdown-arrow" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                             <path d="M1 1L5 5L9 1" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                           </svg>
                           {open === "Status" && (
                             <div className="list-body">
                               <ul className="list">
                                 <li>All Status</li>
                                 <li>New</li>
                                 <li>On Process</li>
                                 <li>Late Order</li>
                               </ul>
                             </div>
                           )}
                         </th>
<th>Details</th>
                     </tr>
                   </thead>
                   <tbody className=' text-center'>
                     {orders.map((order, index) => (
                       <React.Fragment key={index}>
                         <tr className=' text-center'>
                         
                           <td className="order-id d-flex align-items-center gap-2" >
                            
                            <span style={{
                                fontSize:"32px"
                            }}>{order.icon}</span>
                            
                            <span>{order.name}</span>
                           </td>
                           <td>{order.id} <FaRegCopy style={{
                        color:"#8b8d97",
                        fontSize:"14px"
                    }}/></td>
                           <td>{order.date}</td>
                           <td>{order.point}</td>
                           
                       <td>
  <span className={`status ${order.status.toLowerCase().replace(/\s/g, '-')}`}>
    {order.status}
  </span>
</td>

                           <td>
                             <span
                               className="order-details"
                               onClick={() => toggleDetails(index)}
                             >
                               ...
                             </span>
                           </td>
                         </tr>
         
                      {activeRow === index && (
          <>
         
             <tr className="details-row headers-row">
               <td colSpan="9">
                 <div className="order-details-box header">
                   <div className="section "
                    style={{
                     color:"#999999"
                   }}>Full Name</div>
                   <div className="section"   style={{
                     color:"#999999"
                   }}>PHONE</div>
         
         
                   <div className="section"   style={{
                     color:"#999999"
                   }}>EMAIL
                   </div>
                   <div className="section"   style={{
                     color:"#999999"
                   }}>COUNTRY</div>
         
                   <div className="section"   style={{
                     color:"#999999"
                   }}>DATE</div>
         
                   <div className="section"   style={{
                     color:"#999999"
                   }}>Time</div>
         
                   <div className="section"  style={{
                     color:"#999999"
                   }}>Print</div>
                 </div>
               </td>
             </tr>
         
             
             <tr className="details-row values-row">
               <td colSpan="9">
                 <div className="order-details-box values">
                   <h3 className="section">Osama Ali alabyaare</h3>
                   <h3 className="section">+20 1012345678</h3>
                   <h3 className="section">osama@email.com</h3>
                   <h3 className="section">Egypt</h3>
                   <h3 className="section">12 Aug 2022- 12:25 am</h3>
                   <h3 className="section">12:00 PM</h3>
                   <div   className="product-header"
          onClick={() => setOpen(open === "Confirm" ? null : "Confirm")}>
         
           Confirm
           <svg className="dropdown-arrow" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path d="M1 1L5 5L9 1" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
           </svg>
              {open === "Confirm" && (
                                 <div className="list-body">
                                   <ul className="list">
                                     <li>All Products</li>
                                     <li>Social media</li>
                                     <li>E-marketing</li>
                                   </ul>
                                 </div>
                               )}
         
         
                   </div>
                 </div>
               </td>
             </tr>
           <>
         
         
         {/* ////////////////////// */}
             <tr className="details-row headers-row">
               <td colSpan="9">
                 <div className="order-details-box header">
                   <div className="section"    style={{
                     color:"#999999"
                   }}>ORDER TYPE</div>
                   <div className="section"    style={{
                     color:"#999999"
                   }}>CATEGORY</div>
                   <div className="section"    style={{
                     color:"#999999"
                   }}>SKU</div>
                   <div className="section"    style={{
                     color:"#999999"
                   }}>DURATION</div>
                   <div className="section"    style={{
                     color:"#999999"
                   }}>START</div>
                   <div className="section"    style={{
                     color:"#999999"
                   }}>ENDS</div>
                   <div className="section"    style={{
                     color:"#999999"
                   }}>DAYS</div>
               
                 </div>
               </td>
             </tr>
         
             
             <tr className="details-row values-row">
               <td colSpan="9">
                 <div className="order-details-box values">
                   <h3 className="section">Service</h3>
                   <h3 className="section">Social media</h3>
                   <h3 className="section">#6580</h3>
                   <h3 className="section">1 month</h3>
                   <h3 className="section">24 may 2025</h3>
                   <h3 className="section">24 may 2025</h3>
                   <h3 className="section">30</h3>
          
                 </div>
               </td>
             </tr>
         {/* //////////////////////////////////// */}
         
           <>
         
             <tr className="details-row headers-row">
               <td colSpan="9">
                 <div className="order-details-box header">
                   <div className="section"    style={{
                     color:"#999999"
                   }}>PRICE</div>
                   <div className="section"   style={{
                     color:"#999999"
                   }}>TOTAL AMOUNT</div>
                   <div className="section"    style={{
                     color:"#999999"
                   }}>PAYMENT METHOD</div>
                   <div className="section"    style={{
                     color:"#999999"
                   }}>BANK NAME</div>
                   <div className="section"    style={{
                     color:"#999999"
                   }}>ACCOUNT NO</div>
                   <div className="section"    style={{
                     color:"#999999"
                   }}>DUE DATE</div>
                   <div className="section"    style={{
                     color:"#999999"
                   }}>PAYMENT STATUS</div>
                 </div>
               </td>
             </tr>
         
             
             <tr className="details-row values-row">
               <td colSpan="9">
                 <div className="order-details-box values">
                   <h3 className="section">EGP200</h3>
                   <h3 className="section">EGP200</h3>
                   <h3 className="section">credit card</h3>
                   <h3 className="section">+insta</h3>
                   <h3 className="section">********65</h3>
                   <h3 className="section">24 may 2025</h3>
         <div className="succ">
           <span className="icon-circle">
             <FaCheck className="icon" />
           </span>
           Successful
         </div>
         
         
                 </div>
               </td>
             </tr>
         
             
           </>
             
           </>
             
           </>
           
         )}
         
                       </React.Fragment>
                     ))}
                   </tbody>
                 </table>
               </div>
    </div>
  )
}
